import AppSidebar from "../../components/AppSidebar"
import AppHeader from "../../components/AppHeader"
import PageHeader from "../../components/PageHeader"
import ProductService from "../../services/ProductService"
import { useEffect, useState, useCallback } from "react"
import { ToastContainer, toast } from "react-toastify"
import ViewProductModal from "./ViewProductModal"
import ImportFile from "../../modals/ImportFile"
import Pagination from '../../components/Pagination';
import CommonTable from '../../components/CommonTable';
import Filters from '../../components/Filters';
import UseDebounce from '../../hooks/UseDebounce';
import { PageLimit } from '../../utils/ConstantUtils';
import { DebounceDelay } from '../../utils/ConstantUtils'

const ListProduct = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const pageLimit = PageLimit;
    const [itemsPerPage, setPageLimit] = useState(pageLimit);
    const offset = (currentPage - 1) * itemsPerPage;
    const [appliedFilters, setAppliedFilters] = useState({});
    const debouncedSearchTerm = UseDebounce(searchTerm, DebounceDelay || 100);

    const columns = [
        { Header: '', accessor: '', sample: 'Sample Data' },
        { Header: '#', accessor: 'id', sample: 'Sample Data' },
        { Header: 'Name', accessor: 'name', sample: 'Sample Data' },
        { Header: 'Category', accessor: 'category.name', sample: 'Sample Data' },
        { Header: 'Type', accessor: 'type', sample: 'Sample Data' },
        { Header: 'HSN/SAC', accessor: 'identification_code', sample: 'Sample Data' },
        { Header: 'SKU', accessor: 'sku', sample: 'Sample Data' },
        { Header: 'Status', accessor: 'status', sample: 'Sample Data' },
        { Header: 'Qty', accessor: 'quantity', sample: 'Sample Data' },
        { Header: 'Display Price', accessor: 'display_price', sample: 'Sample Data' },
        { Header: 'Selling Price', accessor: 'selling_price', sample: 'Sample Data' },
        { Header: 'Weight', accessor: 'weight', sample: 'Sample Data' },
        { Header: 'In Stock', accessor: 'in_stock', sample: 'Sample Data' },
        { Header: 'Action', accessor: 'action', sample: 'Sample Data' },

    ];
    const [selectedRows, setSelectedRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState({});
    const [showEditModal, setShowEditModal] = useState(false);
    const [alert, setAlert] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);

    const fetchProducts = useCallback(async () => {
        try {
            const products = await ProductService.getAll({
                page: currentPage,
                limit: itemsPerPage,
                search: debouncedSearchTerm,
                offset: offset,
                filters: appliedFilters,
            });
            if (products.status === 200 && products.data.success) {
                setRows(products?.data?.data?.products);
                setTotalPages(products?.data?.data?.totalPages);
                setCurrentPage(products?.data?.data?.currentPage);
            } else {
                console.error('Error in fetching products data:', products);
            }
        } catch (error) {
            console.error("Error in fetching products", error)
            toast.error(error?.response?.data?.message || error?.message);
            setError(error);
        } finally {
            setLoading(false);
        }
    }, [currentPage, itemsPerPage, debouncedSearchTerm, offset, appliedFilters]);

    useEffect(() => {
        fetchProducts()
    }, [appliedFilters, fetchProducts])

    const handleEditClick = (products) => {
        setShowEditModal(true);
        setSelectedProduct(products)
    }

    const handleClose = () => {
        setShowEditModal(false);
    }
    const handleSave = async (data) => {
        try {
            const response = await ProductService.update(selectedProduct.id, { data });
            if (response.status === 200) {
                toast.success(response?.data?.message);
                fetchProducts();
            }
            setShowEditModal(false);
        } catch (error) {
            console.error("Error in updating product", error)
            toast.error(error?.response?.data?.message || error?.message);
            setError(error);
        }
    }
    const handleButtonClick = () => {
        setShowImportModal(true);
    };
    const handleImport = (file) => {
        setShowImportModal(false);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handleItemsPerPageChange = (e) => {
        setCurrentPage(1);
        setPageLimit(e.target.value);
    };

    const handleFilterSubmit = (newFilters) => {
        setAppliedFilters(newFilters);
    };

    const onSubmitImport = async (data) => {
        setLoading(true);
        try {
            const response = await ProductService.import(data);
            if (response.status === 201) {
                toast.success(response?.data?.message);
                fetchProducts();
            }
            setShowImportModal(false);
        } catch (error) {
            setLoading(false);
            console.error("Error in updating product", error)
            setError(error);
            toast.error(error?.response?.data?.message || error?.message);
        } finally {
            setLoading(false);
        }
    }

    const getStatusBadgeClass = (status) => {
        switch (status) {
            case 'published':
                return 'badge bg-success';
            case 'drafted':
                return 'badge bg-danger';
            default:
                return 'badge bg-dark';
        }
    };

    const filterFields = [
        { name: 'name', placeholder: 'Name', Dropdown: "yes" },
        { name: 'category_id', placeholder: 'Category', Dropdown: "yes" },
        { name: 'type', placeholder: 'Type', Dropdown: "yes" },
        { name: 'identification_code', placeholder: 'ID Code', Dropdown: "yes" },
        { name: 'sku', placeholder: 'SKU', Dropdown: "yes" },
        { name: 'quantity', placeholder: 'Quantity', Dropdown: "yes" },
        { name: 'display_price', placeholder: 'Display Price', Dropdown: "yes" },
        { name: 'selling_price', placeholder: 'Selling Price', Dropdown: "yes" },
        { name: 'weight', placeholder: 'Weight', Dropdown: "yes" },
        { name: 'status', placeholder: 'Status', Dropdown: "yes" },
    ];

    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader title='Product' />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 ">
                            <PageHeader
                                title="Product"
                                button_label="Create"
                                link_to="/products/create"
                                className="btn btn-sm btn-primary me-2"
                                button_label1="Import"
                                buttonAttributes1={{ onClick: handleButtonClick }}
                                className1="btn btn-sm btn-secondary"
                            />
                            {alert && (
                                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                    <strong> {error}!</strong>
                                    <button type="button" onClick={() => setAlert(false)} className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                </div>
                            )}
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="contactsListPane" role="tabpanel" aria-labelledby="contactsListTab">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <form>
                                                        <div className="input-group input-group-flush input-group-merge input-group-reverse">
                                                            <input
                                                                className="form-control list-search"
                                                                type="search"
                                                                placeholder="Search"
                                                                value={searchTerm}
                                                                onChange={handleSearchChange}
                                                            />
                                                            <span className="input-group-text">
                                                                <i className="fe fe-search" />
                                                            </span>
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="col-auto me-n3">
                                                    <form>
                                                        <select
                                                            className="form-select form-select-sm form-control-flush"
                                                            value={itemsPerPage}
                                                            onChange={handleItemsPerPageChange}
                                                        >
                                                            <option value="20">20 per page</option>
                                                            <option value="40">40 per page</option>
                                                            <option value="60">60 per page</option>
                                                            <option value="100">100 per page</option>
                                                        </select>
                                                    </form>
                                                </div>
                                                <div className="col-auto">
                                                    {/* Use the Filters component here */}
                                                    <Filters filterFields={filterFields} onApplyFilters={handleFilterSubmit} getFilterService={ProductService.getProductFilter} />
                                                </div>
                                            </div>
                                        </div>
                                        {/* Common Table component*/}
                                        <CommonTable
                                            loading={loading}
                                            rows={rows}
                                            columns={columns}
                                            selectedRows={selectedRows}
                                            setSelectedRows={setSelectedRows}
                                            handleEditClick={handleEditClick}
                                            basePath="products"
                                            showLimitedOptions={true}
                                            offset={offset}
                                            getStatusBadgeClass={getStatusBadgeClass}
                                            showCheckboxes={false}

                                        />
                                        <ToastContainer />

                                        {/* Pagination Component */}
                                        <Pagination
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            setCurrentPage={setCurrentPage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ViewProductModal data={selectedProduct} show={showEditModal} handleClose={handleClose} handleSave={handleSave} />

            {showImportModal && (
                <ImportFile
                    show={showImportModal}
                    handleClose={() => setShowImportModal(false)}
                    handleImport={handleImport}
                    onSubmitImport={onSubmitImport}
                />
            )}
            <ToastContainer containerId={'main'} />
        </>
    )
}

export default ListProduct